import { ChapterTitle } from '../elements/atoms/chapterTitle/ChapterTitle';
import { HeroText } from '../elements/atoms/heroText/HeroText';
import { PageTitle } from '../elements/atoms/pageTitle/PageTitle';
import { Paragraph } from '../elements/atoms/paragraph/Paragraph';
import { Article } from '../elements/molecules/article/article';
import { Container } from '../elements/molecules/container/Container';
import { Main } from '../elements/molecules/main/Main';
import { PageSection } from '../elements/molecules/pageSection/PageSection';
import { Footer } from '../elements/organisms/footer/Footer';
import { Header } from '../elements/organisms/header/Header';
import { PageWrapper } from '../elements/organisms/pageWrapper/PageWrapper';

export function Toegankelijkheid() {
    return (
        <PageWrapper fullHeight>
            <Header hasBackbutton />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>
                            <PageTitle>Toegankelijkheid</PageTitle>
                            <HeroText>
                                Ksyos levert zorg aan iedereen, met of zonder beperking. We doen daarom ons best om
                                MijnKsyos en onze andere producten en diensten zo toegankelijk mogelijk te maken.
                                Hierbij houden we ons zoveel mogelijk aan de richtlijnen van de zogenoemde Web Content
                                Accessibility Guidelines (WCAG) 2.1 niveau AA.
                            </HeroText>
                        </Article>
                    </PageSection>
                    <PageSection bgColor="white">
                        <Article>
                            <ChapterTitle>Ideeën en suggesties</ChapterTitle>
                            <Paragraph>
                                Omdat we vinden dat toegankelijkheid altijd beter kan, onderzoeken we regelmatig hoe het
                                staat met onze toegankelijkheid. Daarnaast ontvangen we graag je ideeën en suggesties
                                voor verbetering. Op basis hiervan gaan we de toegankelijkheid weer verbeteren.
                            </Paragraph>
                            <Paragraph>
                                Kom je een probleem tegen met deze website? Geef dit dan door per e-mail op{' '}
                                <a
                                    href="mailto:toegankelijkheid@ksyos.nl"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    toegankelijkheid@ksyos.nl
                                </a>
                                .
                            </Paragraph>
                        </Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}
